import service from '@/utils/request'

let base = '/api/v1';
let host ='//ad.gamebrain.io/';
export const getAdsAccountListPage = params => { return service.post(`${base}/adsaccountlist`, params); };
export const editAdsAccount = params => { return service.post(`${base}/editadsaccount`, params); };
export const batchRemoveAdsAccount = params => { return service.post(`${base}/deleteadsaccount`, params); };

export const MainListPage = params => { return service.post(`${base}/mainlistpage`, params); };
export const gethome = params => { return service.post(`${base}/home`, params); };
export const getMainInfo = params => { return service.post(`${base}/mainInfo`, params); };
export const getAccountList = params => { return service.post(`${base}/myaccount`, params); };
export const getProductListData = params => { return service.post(`${base}/getProductListData`, params); };
export const dimensions_json = params => { return service.post(`${base}/dimensions_json`, params); };

export const getLogPage = params => { return service.post(`${base}/getLogPage`, params); };

export const getCampaignListPage = params => { return service.post(`${base}/getCampaignList`, params); };
export const getAdsListPage = params => { return service.post(`${base}/getAdsList`, params); };
export const getCreativeListPage = params => { return service.post(`${base}/getCreativeList`, params); };
export const getCampaignListIndex = params => { return service.post(`${base}/getCampaignIndex`, params); };
export const getcreativedetail = params => { return service.post(`${base}/getcreativedetail`, params); };

//新增接口 2020-10-28
export const getFbPage = params => { return service.post(`/fbcreate/getRelatePage`, params); };
export const createTask = params => { return service.post(`/create/createTask`, params); };
export const getTaskList = params => { return service.post(`/fbcreate/getTaskList`, params); };
export const getTaskDetail = params => { return service.post(`/fbcreate/getTaskDetail`, params); };

export const pushVideo = params => { return service.post(`/fbcreate/pushVideo`, params); };

export const getuploadfilelist = params => { return service.post(`/fbcreate/getuploadfilelist`, params); };

// Facebook  相关
export const getFbMainInfo = params => { return service.post(`${base}/getFbMainInfo`, params); };
export const getFbCampaignListPage = params => { return service.post(`${base}/getFbCampaignListPage`, params); };
export const getFbAdsListPage = params => { return service.post(`${base}/getFbAdsListPage`, params); };
export const getFbCreativeListPage = params => { return service.post(`${base}/getFbCreativeListPage`, params); };
export const AddFbCampagin = params => { return service.post(`${base}/AddFbCampagin`, params); };
export const updateFBAdStatus = params => { return service.post(`${base}/updateFBAdStatus`, params); };
export const updateFbCampagin = params => { return service.post(`${base}/updateFbCampagin`, params); };
export const getFbDefaultDataList = params => { return service.post(`${base}/getFbDefaultDataList`, params); };
export const CreateFbAdsPost = params => { return service.post(`${base}/CreateFbAdsPost`, params); };
export const getInterestsOrBehaviors = params => { return service.post(`/facebook/getInterestsOrBehaviors`, params); };
export const getCustomAudiences = params => { return service.post(`/facebook/getCustomAudiences`, params); };
export const createCustomAudiences = params => { return service.post(`${base}/createCustomAudiences`, params); };
export const searchInterestsByQ = params => { return service.post(`/facebook/getInterestsByQ`, params); };
export const saveFbPostAds = params => { return service.post(`/facebook/saveFbPostAds`, params); };
export const getcampaignList = params => { return service.post(`/facebook/getcampaignList`, params); };

export const get_ads_data = params => { return service.post(`/facebook/get_ads_data`, params); };

export const gettargetingList = params => { return service.post(`/facebook/targetingsearch`, params); };


export const fbCopyCampagin = params => { return service.post(`/facebook/fbCopyCampagin`, params); };

export const fbReachEstimate = params => { return service.post(`/facebook/getreachestimate`, params); };

export const fb_get_account_info = params => { return service.post(`/facebook/get_account_info`, params); };

export const check_shop_status = params => { return service.post(`/facebook/check_shop_status`, params); };

export const get_custom_office = params => { return service.post(`/facebook/get_custom_office`, params); };

export const batchUpdateStatus = params => { return service.post(`/facebook/batchUpdateStatus`, params); };

export const previewVideo = params => { return service.post(`${base}/preview`, params); };

export const getIndustryList = params => { return service.post(`${base}/getIndustryList`, params); };
export const getDefaultDataList = params => { return service.post(`${base}/getDefaultDataList`, params); };

export const getLibListPage = params => { return service.post(`${base}/getLibListPage`, params); };
export const getVideoThumbList = params => { return service.post(`${base}/getVideoThumbList`, params); };
export const getVideoImageInfo = params => { return service.post(`${base}/getVideoImageInfo`, params); };

export const CreateAdsPost = params => { return service.post(`${base}/CreateAdsPost`, params); };
export const updateAdStatus = params => { return service.post(`${base}/updateAdStatus`, params); };
export const updateCampagin = params => { return service.post(`${base}/updateCampagin`, params); };
export const updateBatchCampagin = params => { return service.post(`${base}/updateBatchCampagin`, params); };
export const AddCampagin = params => { return service.post(`${base}/AddCampagin`, params); };
export const updateAdvertiserBudget = params => { return service.post(`${base}/updateAdvertiserBudget`, params); };
export const savePostAds = params => { return service.post(`${base}/savePostAds`, params); };
export const updateCreativeData = params => { return service.post(`${base}/updateCreativeData`, params); };
export const addPostAds = params => { return service.post(`${base}/addPostAds`, params); };
export const copyAdsData = params => { return service.post(`${base}/copyAdsData`, params); };
export const batchCopyAdsData = params => { return service.post(`${base}/batchCopyAdsData`, params); };

export const getProductList = params => { return service.post(`${base}/productList`, params); };
export const editProduct = params => { return service.post(`${base}/editProduct`, params); };
export const batchRemoveProduct = params => { return service.post(`${base}/batchRemoveProduct`, params); };

export const updateTitle = params => { return service.post(`${base}/updateTitle`, params); };
export const getTitleList = params => { return service.post(`${base}/getTitleList`, params); };
export const batchRemoveTitle = params => { return service.post(`${base}/batchRemoveTitle`, params); };

export const updateLandpage = params => { return service.post(`${base}/updateLandpage`, params); };
export const getLandpageList = params => { return service.post(`${base}/getLandpageList`, params); };
export const batchRemoveLandpage = params => { return service.post(`${base}/batchRemoveLandpage`, params); };

export const updateTag = params => { return service.post(`${base}/updateTag`, params); };
export const getTagList = params => { return service.post(`${base}/getTagList`, params); };
export const batchRemoveTag = params => { return service.post(`${base}/batchRemoveTag`, params); };

export const getVideoList = params => { return service.post(`${base}/getVideoList`, params); };
export const batchRemoveVideo = params => { return service.post(`${base}/batchRemoveVideo`, params); };
export const updateVideo = params => { return service.post(`${base}/updateVideo`, params); };


export const getImageList = params => { return service.post(`${base}/getImageList`, params); };
export const batchRemoveImage = params => { return service.post(`${base}/batchRemoveImage`, params); };
export const updateImage = params => { return service.post(`${base}/updateImage`, params); };

export const addRules = params => { return service.post(`${base}/addRules`, params); };
export const getCreateRulesList = params => { return service.post(`${base}/getCreateRulesList`, params); };
export const RemoveRule = params => { return service.post(`${base}/RemoveRule`, params); };
export const joinRule = params => { return service.post(`${base}/joinRule`, params); };
export const advertiserList = params => { return service.post(`${base}/advertiserList`, params); };
export const getCreateDefault = params => { return service.post(`${base}/getCreateDefault`, params); };
export const postCreateAdsRules = params => { return service.post(`${base}/postCreateAdsRules`, params); };
export const postCreateAdsRulesV1 = params => { return service.post(`${base}/postCreateAdsRulesV1`, params); };
export const getAdsCreateRulesListPage = params => { return service.post(`${base}/getAdsCreateRulesListPage`, params); };
export const batchRemoveAdsCreateRules = params => { return service.post(`${base}/batchRemoveAdsCreateRules`, params); };
export const findCreateRules = params => { return service.post(`${base}/findCreateRules`, params); };

export const getAdsCreateRulesListAll = params => { return service.post(`${base}/getAdsCreateRulesListAll`, params); };

export const updateRulesStatus = params => { return service.post(`${base}/updateRulesStatus`, params); };
export const saveCustomRules = params => { return service.post(`${base}/saveCustomRules`, params); };
export const getCustomRules = params => { return service.post(`${base}/getCustomRules`, params); };
export const deleteCustomRules = params => { return service.post(`${base}/deleteCustomRules`, params); };

export const postRunAdsRules = params => { return service.post(`${base}/postRunAdsRules`, params); };

export const getUserListPage = params => { return service.get(`${base}/userlist`, { params: params }); };
export const getUserInfo = params => { return service.post(`${base}/getUserInfo`,params); };
export const editUser = params => { return service.post(`${base}/editUser`,params); };

export const getMessageList = params => { return service.post(`${base}/getMessageList`,params); };

export const getMaterialTags = params => { return service.post(`facebook/getMaterialTags`,params); };

export const getMaterialNum = params => { return service.post(`facebook/getMaterialNum`,params); };

export const getfilelist_json = params => { return service.post(`facebook/getfilelist`,params); };

export const notPushedMaterial = params => { return service.post(`facebook/notPushedMaterial`,params); };

export const getRuleCampaignList = params => { return service.post(`ruleads/getcampaignList`,params); };

export const setRuleAdStatus = params => { return service.post(`ruleads/updateStatus`,params); };
//受众API
export const getAudienceAccount = params => { return service.post(`${base}/getAudienceAccount`, params); };
export const getCustomAudienceAll = params => { return service.post(`${base}/getCustomAudienceAll`, params); };
export const getCustomAudience = params => { return service.post(`${base}/getCustomAudience`, params); };
export const deleteCustomAudience = params => { return service.post(`${base}/deleteCustomAudience`, params); };
export const uploadFileAudience = host+'/api/v1/uploadFileAudience'
export const createFileAudience = params => { return service.post(`${base}/createFileAudience`, params); };
export const updateFileAudience = params => { return service.post(`${base}/updateFileAudience`, params); };
export const getPages = params => { return service.post(`${base}/getPages`, params); };
export const createPageAudience = params => { return service.post(`${base}/createPageAudience`, params); };
export const updatePageAudience = params => { return service.post(`${base}/updatePageAudience`, params); };
export const getApps = params => { return service.post(`${base}/getApps`, params); };
export const getAppEventTypes = params => { return service.post(`${base}/getAppEventTypes`, params); };
export const createAppAudience = params => { return service.post(`${base}/createAppAudience`, params); };
export const updateAppAudience = params => { return service.post(`${base}/updateAppAudience`, params); };
export const getAdVideos = params => { return service.post(`${base}/getAdVideos`, params); };
export const createVideoAudience = params => { return service.post(`${base}/createVideoAudience`, params); };
export const updateVideoAudience = params => { return service.post(`${base}/updateVideoAudience`, params); };
//受众API END
//类似受众API
export const getLookalikeAudienceAll = params => { return service.post(`${base}/getLookalikeAudienceAll`, params); };
export const getLookalikeAudience = params => { return service.post(`${base}/getLookalikeAudience`, params); };
export const deleteLookalikeAudience = params => { return service.post(`${base}/deleteLookalikeAudience`, params); };
export const getCreateExistingList = params => { return service.post(`${base}/getCreateExistingList`, params); };
export const createExistingLookalikeAudience = params => { return service.post(`${base}/createExistingLookalikeAudience`, params); };
export const updateExistingLookalikeAudience = params => { return service.post(`${base}/updateExistingLookalikeAudience`, params); };
export const getCreateCampaignList = params => { return service.post(`${base}/getCreateCampaignList`, params); };
export const createCampaignLookalikeAudience = params => { return service.post(`${base}/createCampaignLookalikeAudience`, params); };
export const updateCampaignLookalikeAudience = params => { return service.post(`${base}/updateCampaignLookalikeAudience`, params); };
export const getCreatePageList = params => { return service.post(`${base}/getCreatePageList`, params); };
export const createPageLookalikeAudience = params => { return service.post(`${base}/createPageLookalikeAudience`, params); };
export const updatePageLookalikeAudience = params => { return service.post(`${base}/updatePageLookalikeAudience`, params); };
//类似受众API END

export const getLtvMain = params => { return service.post('/appsflyer/index',params); };
export const get_ltv_total_data = params => { return service.post('/appsflyer/get_ltv_total_data',params); };
export const ltv_json_data = params => { return service.post('/appsflyer/ltv_json_data',params); };

//log
export const getLogListPage = params => { return service.post('/log/getLogListPage',params); };

//规则库
export const createInterestRule = params => { return service.post('/rulelib/createInterestRule',params); };
export const getInterestRulePage = params => { return service.post('/rulelib/getInterestRulePage',params); };
export const deleteInterestRule = params => { return service.post('/rulelib/deleteInterestRule',params); };


//Adwords
export const get_google_default_data = params => { return service.post('/adwords/get_default_data',params); };
export const get_google_campaign_list = params => { return service.post('/adwords/get_campaign_list',params); };
export const get_google_campaign_report = params => { return service.post('/adwords/get_campaign_report',params); };
export const pushGoogleVideos = params => { return service.post('/youtube/pushVideo',params); };


//TikTok
export const get_tiktok_default_data = params => { return service.post('/tiktok/getDefaultData',params); };
export const get_tiktok_app_data = params => { return service.post('/tiktok/get_app_list',params); };
export const create_tiktok_app = params => { return service.post('/tiktok/create_app',params); };
export const get_campaign_country_data = params => { return service.post('/tiktok/get_campaign_country_data',params); };


//Toutiao
export const get_toutiao_default_data = params => { return service.post('/toutiao/getDefaultData',params); };


//标签
export const get_label_json = params => { return service.post('/facebook/label_json',params); };
export const add_label = params => { return service.post('/facebook/add_label',params); };

export const addNotice = params => { return service.post('/user/addNotice',params); };
export const getnoticeList = params => { return service.post('/user/noticeList',params); };
//新面板信息

export const getPanelTotal = params => { return service.post(`/advertiser_panel/getPanelTotal`, params); };
export const getAdvertiserPanel = params => { return service.post(`/advertiser_panel/getAdvertiserPanel`, params); };
export const getCampaignPanel = params => { return service.post(`/advertiser_panel/getCampaignPanel`, params); };
export const getSetPanel = params => { return service.post(`/advertiser_panel/getSetPanel`, params); };
export const getAdPanel = params => { return service.post(`/advertiser_panel/getAdPanel`, params); };
export const getWarningAdvertiser = params => { return service.post(`/advertiser_panel/getWarningAdvertiser`, params); };

// 新面板操作
export const updateCampaignPanel = params => { return service.post(`/advertiser_panel_option/updateCampaign`, params); };
export const updateAdSetPanel = params => { return service.post(`/advertiser_panel_option/updateAdSet`, params); };
export const updateAdPanel = params => { return service.post(`/advertiser_panel_option/updateAd`, params); };
export const copyCampaignPanel = params => { return service.post(`/advertiser_panel_option/copyCampaign`, params); };
export const copyAdSetPanel = params => { return service.post(`/advertiser_panel_option/copyAdSet`, params); };
export const copyAdPanel = params => { return service.post(`/advertiser_panel_option/copyAd`, params); };

export const deleteCampaignPanel = params => { return service.post(`/advertiser_panel_option/deleteCampaign`, params); };
export const deleteAdSetPanel = params => { return service.post(`/advertiser_panel_option/deleteAdSet`, params); };
export const deleteAdPanel = params => { return service.post(`/advertiser_panel_option/deleteAd`, params); };

export const appiconupload = host+'/api/v1/appicon'
export const avatarupload = host+'/api/v1/avatar'
export const videoupload = host+'/api/v1/videoupload'
export const imageupload = host+'api/v1/imageupload'


// WEBPACK FOOTER //
// ./src/api/api.js